import { Action } from '@ngrx/store';
import { RecommendationCategoryInterface } from 'app/recommendation/models/recommendation-category.model';

import { RecommendationInterface, RecommendationTemplateRuleInterface } from '../../models';

import { RecommendationActionType } from './recommendation-action-type.enum';


export class CreateRecommendationTemplate implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.CreateRecommendationTemplate;

  constructor(public readonly payload: RecommendationInterface) { }
}

export class CreateRecommendationTemplateCompleted implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.CreateRecommendationTemplateCompleted;

  constructor(public readonly payload: RecommendationInterface) { }
}

export class CreateRecommendationTemplateFailed implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.CreateRecommendationTemplateFailed;

  constructor(public readonly payload: string) { }
}

export class CreateRecommendationCategory implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.CreateRecommendationCategory;

  constructor(public readonly payload: RecommendationCategoryInterface) { }
}

export class CreateRecommendationCategoryCompleted implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.CreateRecommendationCategoryCompleted;

  constructor(public readonly payload: RecommendationCategoryInterface) { }
}

export class CreateRecommendationCategoryFailed implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.CreateRecommendationCategoryFailed;

  constructor(public readonly payload: string) { }
}

export class CreateRecommendationTemplateRule implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.CreateRecommendationTemplateRule;

  constructor(public readonly payload: {recommendation: RecommendationInterface, rule: RecommendationTemplateRuleInterface}) { }
}

export class CreateRecommendationTemplateRuleCompleted implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.CreateRecommendationTemplateRuleCompleted;

  constructor(public readonly payload: RecommendationInterface) { }
}

export class CreateRecommendationTemplateRuleFailed implements Action {
  public readonly type: RecommendationActionType = RecommendationActionType.CreateRecommendationTemplateRuleFailed;

  constructor(public readonly payload: string) { }
}
